import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons';



const LogicDisplay = ({ value, onEdit, courseDesignState }) => {
    const [tooltipContent, setTooltipContent] = useState('');
    const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });
    const [isTooltipVisible, setIsTooltipVisible] = useState(false);
    

    const pattern = /\(([\w-]+),\s*(\d+)\)/g;

let hoverTimeout;
let showTimeout;

const handleMouseEnter = (dataID, optionNumber, event) => {
    clearTimeout(hoverTimeout); // Clear any existing hide timeout
    clearTimeout(showTimeout); // Clear any existing show timeout
    
    // Small delay before showing to prevent rapid flickering
    showTimeout = setTimeout(() => {
        const questionItem = courseDesignState.find(item => item.dataID === dataID);
        if (questionItem) {
            const optionsArray = questionItem.questionOptions.split('|||');
            const optionText = optionsArray[Number(optionNumber) - 1] || '';
            setTooltipContent(`Question: ${questionItem.dataText}\n\nAnswer: ${optionText}`);
        }
        setTooltipPosition({ x: event.clientX + 10, y: event.clientY - 60 }); // Offset to avoid cursor
        setIsTooltipVisible(true);
    }, 150); // Small delay before showing
};

const handleMouseLeave = () => {
    clearTimeout(showTimeout); // Cancel any pending show
    hoverTimeout = setTimeout(() => {
        setIsTooltipVisible(false);
        setTooltipContent('');
    }, 300); // Longer delay before hiding
};




    const renderHighlightedText = (text) => {
        const parts = [];
        let lastIndex = 0;

        text.replace(pattern, (match, dataID, optionNumber, offset) => {
            parts.push(text.slice(lastIndex, offset)); // Text before the match
            parts.push(
                <span
                    key={`${dataID}-${optionNumber}`}
                    style={{ 
                        cursor: 'pointer',
                        padding: '2px 4px', // Add padding to create larger hover area
                        margin: '0 1px', // Small margin to separate from adjacent text
                        borderRadius: '3px',
                        transition: 'background-color 0.2s ease'
                    }}
                    onMouseEnter={(e) => handleMouseEnter(dataID, optionNumber, e)}
                    onMouseLeave={handleMouseLeave}
                >
                    {match}
                </span>
            );
            lastIndex = offset + match.length;
        });

        parts.push(text.slice(lastIndex)); // Remaining text after the last match
        return parts;
    };

    return (
        <div style={{ position: 'relative' }}>
            <div style={{ display: 'flex', alignItems: 'center', fontFamily: 'var(--font-mono)', whiteSpace: 'pre-wrap' }}>
    <div style={{ flexGrow: 1 }}>
        {renderHighlightedText(value || '')}

    </div>
    <button
    onClick={onEdit}
    style={{
        marginLeft: '8px',
        cursor: 'pointer',
        transform: 'scale(0.67)', // Shrinks to 2/3 of original size
        transformOrigin: 'center', // Ensures scaling occurs from the center
    }}
>
    <FontAwesomeIcon icon={faPencilAlt} />
</button>
</div>


            {isTooltipVisible && tooltipContent && (
                <div
                            className="logic-hover-display"

                    style={{
                        top: tooltipPosition.y,
                        left: tooltipPosition.x,
                        pointerEvents: 'none', // Prevent tooltip from interfering with mouse events
                        opacity: isTooltipVisible ? 1 : 0,
                        transition: 'opacity 0.2s ease-in-out'
                    }}
                >
                    {tooltipContent}
                </div>
            )}
        </div>
    );
};

export default LogicDisplay;
